// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"marker-display_wrapper_2mdc4","tagWrapper":"marker-display_tagWrapper_252xN","icon":"marker-display_icon_hARtk"};